import { useContext } from "react";
import { useHistory } from "react-router";
import { Row, Col, Button } from "react-bootstrap";

import { AppContext } from "context/appContext";
import { DashboardSelect } from "components/dashboard/DashboardSelect";
import HoverAuthorizeTooltip from "components/authorize/AuthorizeTooltip";
import { walletModalTrigger } from "hooks/wallet";
import { DashboardActionDropdown } from "components/dashboard/DashboardActionDropdown";

export const DashboardHeader = () => {
    const history = useHistory();
    const { storeData } = useContext(AppContext);
    const { dashboard, organization } = storeData;
    const { currentOrgId } = organization;
    const { currentDashboard } = dashboard;

    return (
        <Row>
            <Col sm="12">
                <div className="dashboard-header">
                    <div className="dashboard-action">
                        <DashboardSelect />
                        <HoverAuthorizeTooltip
                            permission="dashboard:create"
                            className="float-left"
                        >
                            <Button
                                variant="primary"
                                onClick={() => {
                                    walletModalTrigger(() => {
                                        history.push(
                                            `/dashboard/${currentDashboard.key}/new-charts?organization_id=${currentOrgId}`
                                        );
                                    });
                                }}
                            >
                                Add Widget
                            </Button>
                        </HoverAuthorizeTooltip>
                        <DashboardActionDropdown />
                    </div>
                </div>
            </Col>
        </Row>
    );
};
